import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationGroup } from './ProjectNavigation';

export default function MobileNavigation({ admin, paperReviewer, close }: { admin: boolean; paperReviewer: boolean; close: () => void }) {
  const { pathname } = useLocation();
  const group = navigationGroup(pathname);
  const destinations = [
    { path: '/', label: 'Racing', group: 'racing' },
    { path: '/strategy/auto', label: 'Auto', group: 'auto' },
    { path: '/hub', label: 'Hub', group: 'hub' },
    { path: '/my-bets', label: 'My Bets', group: 'bets' },
    { path: '/strategy/bucket-bets', label: 'Bet Buckets', group: 'buckets' },
    { path: '/strategy/bucket-next-up', label: 'Bucket Next Up', group: 'bucket-next-up' },
  ];
  return <nav className="mobile-primary-nav" aria-label="Quick navigation">
    {destinations.map(item => <Link key={item.path} to={item.path} onClick={close}
      className={group === item.group ? 'active' : ''}
      aria-current={group === item.group ? 'page' : undefined}>{item.label}</Link>)}
  </nav>;
}
